import { makeObservable, observable } from "mobx";
// import ManagerEntity from "../Manager/Manager";
// import { encodeMidiMessage } from "../Player/Player";

class CountDown {
    countDown: number = 0;
    intervalId: any = -1;
    startCountDown(callback?: any) {
        // clear previous interval if it exists
        if (this.intervalId != -1) {
            this.resetCountDown();
        }

        this.countDown = 1;

        this.intervalId = setInterval(() => {
            if (this.countDown < 3) {
                this.countDown = this.countDown + 1;
                this.playSound();
            } else {
                // if countDown === 3 then call callback and  reset countDown
                if (callback) {
                    callback();
                }
                this.resetCountDown();
            }
        }, 1000);
    }
    resetCountDown() {
        clearInterval(this.intervalId);
        this.intervalId = -1;
        this.countDown = 0;
    }
    // we are playing this sound on interval 1 2 3 before start
    playSound() {
        // if (ManagerEntity.player) {
        //     try {
        //         const noteOn: any = {
        //             channel: 0,
        //             delta: 0,
        //             noteOn: {
        //                 noteNumber: 55,
        //                 velocity: 0.1,
        //             },
        //         };
        //         let time = performance.now();
        //         let msg = encodeMidiMessage(noteOn);
        //         if (ManagerEntity.player._output) {
        //             if ("_noteOn" in ManagerEntity.player._output) {
        //                 (ManagerEntity.player._output._noteOn as any)(noteOn, time);
        //             }
        //         } else {
        //             ManagerEntity.player.send(msg, time);
        //         }
        //     } catch (err) {
        //         throw err
        //     }
        // }
    }
    constructor() {
        makeObservable(this, {
            countDown: observable
        })
    }
}

const CountDownEntity = new CountDown();
export default CountDownEntity;
